import dateToString from '../../../../function/dateToString';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import { defaultPerPageValue } from '../../../../constants/PaginationPerPageConstants';
import { sortValuesPredbezne, sortValuesProcesy } from '../../../../constants/SortConstants';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: LegMaterialListFilter,
  isPredbezna = false,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter.searchTextCislo) {
    updatedSearchParams.set('cisloLegMaterialu', filter.searchTextCislo);
  }

  if (filter.searchTextNazov) {
    updatedSearchParams.set('nazov', filter.searchTextNazov);
  }

  if (filter.searchTextVyraz) {
    updatedSearchParams.set('hladanyVyraz', filter.searchTextVyraz);
  }

  if (filter.searchTextRocnik) {
    updatedSearchParams.set('rocnik', filter.searchTextRocnik);
  }

  if (filter.searchTextRezort) {
    updatedSearchParams.set('rezortCislo', filter.searchTextRezort);
  }

  if (filter.stadium) {
    updatedSearchParams.set('stadium', filter.stadium);
  }

  if (filter?.predkladatel?.uuid) {
    updatedSearchParams.set('predkladatel', filter.predkladatel.uuid);
  }

  if (filter?.institucia?.uuid) {
    updatedSearchParams.set('institucia', filter.institucia.uuid);
  }

  if (filter?.typ?.kod) {
    updatedSearchParams.set('typ', filter.typ.kod);
  }

  if (filter.oblastList && filter.oblastList.length > 0) {
    const oblastList = filter.oblastList.map(oblast => oblast.kod)
      .join(',');
    updatedSearchParams.set('oblastList', oblastList);
  }

  if (filter.datumZmenyOd) {
    updatedSearchParams.set('from', dateToString(filter.datumZmenyOd));
  }

  if (filter.datumZmenyDo) {
    updatedSearchParams.set('to', dateToString(filter.datumZmenyDo));
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if ((isPredbezna && !sortValuesPredbezne.includes(sort[0]))
      || !sortValuesProcesy.includes(sort[0])
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
